/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestId
 */
export type RequestId = string;

/**
 * Check if a given object implements the RequestId interface.
 */
export function instanceOfRequestId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RequestIdFromJSON(json: any): RequestId {
    return RequestIdFromJSONTyped(json, false);
}

export function RequestIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestId {
    return json;
}

export function RequestIdToJSON(value?: RequestId | null): any {
    return value;
}

